export default "__VITE_ASSET__D8drnx8b__"